<template>
    <div class="content-page">
        <table class="table" cellspacing="0" cellpadding="0">
            <tr class="table-top">
                <th>楼层</th>
                <th>房间</th>
            </tr>

            <tr v-for="(floor, index) in tableData" :key="index">
                <th class="floor" width="120px">{{ floor.floorNum }}</th>
                <td class="room" width="100px" v-for="room in floor.child" @click="handleEdit(floor, room)">{{ room.name
                    }}</td>
                <td width="100px">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleShowDialog(floor)">
                    </el-button>
                </td>
            </tr>
        </table>

        <el-dialog :title="openType" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" width="30%">

            <div>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="房间名">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>

                    <el-form-item label="楼层">
                        <div class="form-item-container">
                            <el-input-number v-model="form.floorNum" controls-position="right" :min="1"
                                :max="floorInfo.floorNum" :disabled="true"></el-input-number>
                        </div>
                    </el-form-item>
                </el-form>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="handleDelete()" v-if="openType == '编辑房间'">删除</el-button>
                <el-button type="primary" @click="handleAdd()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
import { getRoomList, editRoom, deleteRoom } from "@/api";
//例如：import 《组件名称》 from '《组件路径》'

export default {
    components: {},
    props: [],
    data() {
        return {
            floorInfo: {},
            roomList: [],

            pageNo: 1,
            pageSize: 100,
            pageCount: 0,

            openType: "新增房间",
            dialogVisible: false,

            form: {
                roomId: '',
                name: '',
                floorNum: 1,
            },

            tableData: []
        };
    },
    computed: {},
    watch: {},
    async mounted() {
        this.floorInfo = JSON.parse(this.$route.query.floorInfo);

        console.log(this.tableData);
        await this.getData();
    },
    methods: {
        async getData() {
            // 对展示数组清空，初始化数据结构
            this.tableData = [];
            for (let i = 1; i <= this.floorInfo.floorNum; i++) {
                this.tableData.push({
                    floorNum: i,
                    child: [],
                })
            }

            // 获取房间列表,处理数据结构
            const tempData = {
                buildingId: this.floorInfo.buildingId,
                pageNo: this.pageNo,
                row: this.pageSize,
            }

            let res = await getRoomList(tempData);
            this.roomList = res.data || [];
            for (let i = 1; i <= this.tableData.length; i++) {
                this.roomList.forEach(room => {
                    if (i == room.floorNum) {
                        this.tableData[i - 1].child.push(room);
                    }
                })
            }

            console.log(this.tableData);

            console.log('room', this.roomList);
        },

        // 显示弹窗
        handleShowDialog(floor) {
            this.form.floorNum = floor.floorNum;
            this.openType = "新增房间";
            this.dialogVisible = true;
        },

        // 编辑
        handleEdit(floor, room) {
            this.form.floorNum = floor.floorNum;
            this.form.name = room.name;
            this.form.roomId = room.roomId;

            this.openType = "编辑房间";
            this.dialogVisible = true;
        },

        // 新增
        async handleAdd() {
            if (this.form.name == '') {
                this.$message({
                    type: 'error',
                    message: `请输入房间名称`
                });

                return
            }

            let tempData = {}
            Object.assign(tempData, this.form);
            tempData.buildingId = this.floorInfo.buildingId;

            const res = await editRoom(tempData);
            if (res.code == 1) {
                this.$message({
                    type: 'success',
                    message: `操作成功`
                });

                this.dialogVisible = false;
                this.form = {
                    roomId: '',
                    name: '',
                    floorNum: 1,
                    buildingId: this.floorInfo.buildingId,
                }

                // 更新列表
                await this.getData()
            } else {
                this.$message({
                    type: 'error',
                    message: `${res.msg}`
                });
            }
        },

        // 删除
        handleDelete() {
            this.$confirm('确认是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const tempData = {
                    roomId: this.form.roomId
                }
                const res = await deleteRoom(tempData)
                if (res.code == 1) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.form = {
                        roomId: '',
                        name: '',
                        floorNum: 1,
                        buildingId: this.floorInfo.buildingId,
                    }

                    this.dialogVisible = false;
                    // 更新列表
                    this.getData()
                }

            }).catch(() => {
            });
        },

        // 取消
        handleCancel() { },



    },
};
</script>

<style lang="less" scoped>
.content-page {
    width: 100%;
    overflow-x: scroll;
}

.table {
    padding: 0;
    margin: 0;

    td {
        box-sizing: border-box;
        padding: 10px 0;

        border-radius: 10px;
        border: 1px solid #fff;
        text-align: center;
        background-color: #f8f9fa;
    }

    &-top {
        th {
            font-size: 20px;
            font-weight: bold;

            box-sizing: border-box;
            padding: 10px 0;
        }
    }

    .floor {
        color: #fff;
        font-size: 20px;
        font-weight: bold;

        background-color: #E6A23C;

        box-sizing: border-box;
        border-bottom: 1px solid #fff;
    }

    .room {
        color: #fff;
        font-size: 17px;
        font-weight: bold;

        background-color: #67C23A;

        cursor: pointer;
    }
}
</style>